import {
  useQuery,
} from '@tanstack/react-query';
import {
  ToDoCountResponseDTO,
} from 'dtos';
import {
  getApiToDoGetUnreadToDoCountOfUser,
} from 'endpoints';

export default function useUserToDosCount() {
  return useQuery<ToDoCountResponseDTO | void, Error>({
    queryKey: ['user-to-dos-count'],
    queryFn: getApiToDoGetUnreadToDoCountOfUser,
  });
}
